export const LOAD_PROFILE = 'Dyzio/Profile/LOAD_PROFILE';
export const LOAD_INSTAGRAM = 'Dyzio/Profile/LOAD_INSTAGRAM';
export const LOAD_PAGE = 'Dyzio/Profile/LOAD_PAGE';



// WEBPACK FOOTER //
// ./src/containers/profile/constants.js